import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PopoverController, NavController, ViewController } from 'ionic-angular';
import { CoffeShopService } from '../../providers/coffe-shop/coffe-shop.service';

@Component({
  selector: 'coffe-shop-header',
  templateUrl: 'coffe-shop-header.html'
})
export class CoffeShopHeaderComponent {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() readytime: string;
  @Input() flipclock: number;
  @Input() showPopover: boolean;
  @Input() showImage: boolean;
  @Input() image: string;
  @Input() mainText: 'title' | 'subtitle';
  @Input() headerType: 'banner' | 'header';
  @Output() backButtonEvent = new EventEmitter();
  @Input() IsFrombarberShop: boolean;
  @Input() shop: any;
  @Input() IsNewHeader: boolean;

  bannerList: any[] = [];
  constructor(public popoverCtrl: PopoverController, public navCtrl: NavController, public viewCtrl: ViewController, public coffeShopService: CoffeShopService) {


  } //public popoverCtrl: PopoverController, 
  public backButton() {
    this.backButtonEvent.emit('backButton');
  }

  ngOnInit() {
    if (this.shop && typeof(this.shop.users) != "undefined") {
      
      let selecteduser = this.shop.users[0];
      if (selecteduser) {
        if (selecteduser.profile_data && typeof (selecteduser.profile_data) == "string") {
          selecteduser.profile_data = JSON.parse(selecteduser.profile_data);
          if (selecteduser.profile_data && selecteduser.profile_data.image_url && typeof (selecteduser.profile_data.image_url) == "string") {
            selecteduser.profile_data.image_url = JSON.parse(selecteduser.profile_data.image_url);
            if (selecteduser.profile_data.image_url && selecteduser.profile_data.image_url.length > 0) {
             this.bannerList = selecteduser.profile_data.image_url.filter(element => { return element });
            }
          }
        } else {
          if(selecteduser.profile_data && selecteduser.profile_data.image_url){
            this.bannerList = selecteduser.profile_data.image_url.filter(element => { return element });
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/coffe-shop-header/coffe-shop-header.ts